const initialState = {
    data: null,
}

export const viewerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'VIEWER_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'VIEWER_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default viewerReducer;